


























































































































import { apiClient } from "@/services/api-client";
import { mapGetters } from "vuex";
import NoLocationSelected from "../components/NoLocationSelected.vue";
import LoadingBlock from "../components/LoadingBlock.vue";
import BaseIconAlert from "@/components/Base/BaseIconAlert.vue";
import { highlightMixin } from "@/mixins/highlightMixin";
import TheBannerSmall from "@/components/The/TheBannerSmall.vue";
import BaseBreadcrumb from "@/components/Base/BaseBreadcrumb.vue";
import TableDynamic from "@/components/TableDynamic.vue";
import BasePage from "@/components/Base/BasePage.vue";
import store from "@/store/store";
import { logPageMixin } from "@/mixins/LogPageMixin";

export default {
  name: "Materieelaanvragen",
  components: {
    BasePage,
    TableDynamic,
    BaseBreadcrumb,
    TheBannerSmall,
    BaseIconAlert,
    LoadingBlock,
    NoLocationSelected
  },
  mixins: [highlightMixin, logPageMixin],
  data() {
    return {
      items: [],
      isLoading: false,
      searchValue: ""
    };
  },
  computed: {
    ...mapGetters([
      "selectedLocationId",
      "selectHasProjectSelected",
      "selectedLocationProjectId",
      "getMultiSetting",
      "getIntSetting",
      "getColumnSetting"
    ]),
    fields() {
      return [
        {
          key: this.getColumnSetting("Materieelaanvragen_Aanvraagnummer")
            .isEnabled
            ? "aanvraagNr"
            : null,
          label: this.$t("shared.aanvraagnummer"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_Aanvraagnummer")
            .order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Ordernummer").isEnabled
            ? "orderNr"
            : null,
          label: this.$t("shared.ordernummer"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_Ordernummer").order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Aanvraagdatum")
            .isEnabled
            ? "aanGevraagdOpDatum"
            : null,
          label: this.$t("shared.aanvraagdatum"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_Aanvraagdatum").order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Verplaatsdatum")
            .isEnabled
            ? "verplaastingsDatum"
            : null,
          label: this.$t("shared.verplaatsdatum"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_Verplaatsdatum")
            .order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Afvoerdatum").isEnabled
            ? "afvoerDatum"
            : null,
          label: this.$t("shared.afvoerdatum"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_Afvoerdatum").order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Status").isEnabled
            ? "status"
            : null,
          label: this.$t("shared.status"),
          sortable: true,
          filterable: this.getColumnSetting("Materieelaanvragen_Status")
            .isEnabled,
          filterableEnum: "enum_aanvraag_status",
          order: this.getColumnSetting("Materieelaanvragen_Status").order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Soort").isEnabled
            ? "type"
            : null,
          label: this.$t("shared.soort"),
          sortable: true,
          filterable: this.getColumnSetting("Materieelaanvragen_Soort")
            .isEnabled,
          filterableEnum: "enum_aanvraag_soort",
          order: this.getColumnSetting("Materieelaanvragen_Soort").order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_AangevraagdDoor")
            .isEnabled
            ? "aanGevraagdDoor"
            : null,
          label: this.$t("shared.aangevraagd_door"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_AangevraagdDoor")
            .order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Afhaalorder").isEnabled
            ? "ophalen"
            : null,
          label: this.$t("shared.afhaalorder"),
          sortable: true,
          filterable: this.getColumnSetting("Materieelaanvragen_Afhaalorder")
            .isEnabled,
          filterableEnum: "bool",
          order: this.getColumnSetting("Materieelaanvragen_Afhaalorder").order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Referentie").isEnabled
            ? "uwReferentie"
            : null,
          label: this.$t("shared.referentie"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_Referentie").order
        },
        {
          key: this.getColumnSetting("Materieelaanvragen_Post").isEnabled
            ? "post"
            : null,
          label: this.$t("shared.element"),
          sortable: true,
          order: this.getColumnSetting("Materieelaanvragen_Post").order
        }
      ];
    },
    filteredItems() {
      if (!this.searchValue) {
        return this.items;
      }

      return this.items.filter(
        item =>
          item.aanvraagNr
            .toLowerCase()
            .includes(this.searchValue.toLowerCase()) ||
          item.aanvraagNr.includes(this.searchValue)
      );
    }
  },
  created() {
    if (!this.selectedLocationId) {
      return;
    }

    this.fetchData();
  },
  methods: {
    boolSetting(settingName) {
      return this.$store.getters.getBoolSetting(settingName);
    },
    fetchData() {
      this.isLoading = true;

      if (!this.selectHasProjectSelected) {
        apiClient
          .getAanvragen({
            materieelLocatie: this.selectedLocationId
          })
          .then(response => {
            this.items = response.aanvragen;
            this.isLoading = false;
          });
      } else {
        apiClient
          .getAanvragenProject({
            materieelLocatie: this.selectedLocationId,
            gebruikerLogin: this.$store.state.auth.username,
            projectNummer: this.selectedLocationProjectId
          })
          .then(response => {
            this.items = response.aanvragen;
            this.isLoading = false;
          });
      }
    },
    fetchProjectData() {
      this.$store.dispatch("projectSelected");
      this.fetchData();
    },
    GetOrderRoute(row) {
      let routeName;

      switch (row.item.type) {
        case "Aanvoer":
          routeName = "MaterieelordersAanvoerDetails";
          break;
        case "Afvoer":
          routeName = "MaterieelordersAfvoerDetails";
          break;
        case "Overige_verplaatsingen":
          routeName = "MaterieelordersVerplaatsingNaarDetails";
          break;
        default:
      }

      return routeName;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters.getMultiSetting("Locatie_ToonAanvragen")) {
      next({ name: "Home" });
    }

    next();
  }
};
